// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-wishlist." + {"173":"5048caa209f6979f","260":"5834a41ae8db6b75","543":"0cd6ce6b09f9261a","547":"037adcc18cf8579a","667":"52f9b57f952cd426","713":"57ef093e6c7d3a7c","775":"01c54f40944540ce","879":"597cb2065c5ccd81"}[chunkId] + ".js";
};